export const managementButtonStyles = {
    primary: 'bg-blue-600 text-white transition-colors hover:bg-blue-700 disabled:opacity-50',
};
